import { CheckCircle, Circle } from "lucide-react";

interface PassIconProps {
  passed: boolean;
}

export default function PassIcon({ passed }: PassIconProps) {
  if (passed) {
    return <CheckCircle className="mr-2 w-5 h-5 shrink-0" />;
  }
  return <Circle className="mr-2 w-5 h-5 shrink-0" />;
}
